import r from "./td-longtail-vue-components99.js";
/* empty css                              */
import e from "./td-longtail-vue-components98.js";
var s = function() {
  var t = this, n = t._self._c, o = t._self._setupProxy;
  return n(o.component, { tag: "component", staticClass: "arrow", class: `arrow--${t.direction} ${t.setPosition ? "arrow--set-position" : ""}`, attrs: { "no-styling": "", tag: t.tag, type: o.isLink ? "button" : void 0 }, on: { click: function(_) {
    return t.$emit("change", t.direction);
  } } });
}, i = [], a = /* @__PURE__ */ e(
  r,
  s,
  i,
  !1,
  null,
  "922b0547"
);
const l = a.exports;
export {
  l as default
};
